/**
 * The conversation on screen right now (a channel or a direct message), so a
 * live message for it doesn't bump the Chat list's unread badge — the stream
 * marks it read a moment later anyway, and the badge would only flicker.
 * Module state: one app, one visible conversation (desktop or phone).
 */
export type ActiveChat = { kind: 'topic'; topicId: string } | { kind: 'dm'; threadId: string };

let active: ActiveChat | null = null;

export function setActiveChat(next: ActiveChat | null): void {
  active = next;
}

export function getActiveChat(): ActiveChat | null {
  if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return null;
  return active;
}

export function isActiveTopic(topicId: string): boolean {
  const a = getActiveChat();
  return a?.kind === 'topic' && a.topicId === topicId;
}

export function isActiveDm(threadId: string): boolean {
  const a = getActiveChat();
  return a?.kind === 'dm' && a.threadId === threadId;
}
